var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7764EA",
    d: "M3 11.5a.963.963 0 0 1-.706-.294A.963.963 0 0 1 2 10.5v-5c0-.275.098-.51.294-.706A.963.963 0 0 1 3 4.5h.5v-1c0-.692.244-1.281.731-1.769A2.41 2.41 0 0 1 6 1a2.41 2.41 0 0 1 1.769.731A2.41 2.41 0 0 1 8.5 3.5v1H9c.275 0 .51.098.706.294A.963.963 0 0 1 10 5.5v5c0 .275-.098.51-.294.706A.963.963 0 0 1 9 11.5H3Zm1.5-7h3v-1c0-.417-.146-.771-.438-1.063A1.447 1.447 0 0 0 6 2c-.417 0-.77.146-1.063.437A1.447 1.447 0 0 0 4.5 3.5v1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFilled);
export default __webpack_public_path__ + "static/media/lock-filled.5c00f13258264f4affdf6cc5700d0abe.svg";
export { ForwardRef as ReactComponent };